module.exports = __webpack_public_path__ + "static/gem-essential-cou-761e024b9fc54c09c765b4d1169affd8.png";